import { supportOfficers } from '@exclusionmodule/models';
import { Component, Input, OnInit, inject } from '@angular/core';
import { ApiServiceService, NotificationService } from '@oneeducation/app-core';
import { exclusionsModel } from '@exclusionmodule/models';
import { EXCLUSION_ENDPOINT } from '@shared/properties';

const NO_ASSIGNED_SUPPORT_OFFICERS =
  'No support officers have been assigned for ';
@Component({
  selector: 'app-exclusion-support-officers',
  templateUrl: './exclusion-support-officers.component.html',
  styleUrls: ['./exclusion-support-officers.component.scss'],
  standalone: false
})
export class ExclusionSupportOfficersComponent implements OnInit {
  private readonly apiService = inject(ApiServiceService);
  private readonly notificationService = inject(NotificationService);

  @Input() exclusionId: number;
  @Input() pupilName: string;
  supportOfficer: supportOfficers[];
  isSupportOfficerAssociated = true;
  noSupportOfficerAssociatedText: string;

  ngOnInit() {
    this.getSupportOfficers();
  }

  getSupportOfficers() {
    this.apiService
      .getAll<
        exclusionsModel[]
      >(EXCLUSION_ENDPOINT.GetExclusion.replace('{exclusionId}', this.exclusionId?.toString()), '')
      .subscribe({
        next: (x: any) => {
          this.supportOfficer = x.exclusion.supportOfficer;
          if (
            this.supportOfficer === undefined ||
            this.supportOfficer.length === 0
          ) {
            this.isSupportOfficerAssociated = false;
            this.noSupportOfficerAssociatedText =
              NO_ASSIGNED_SUPPORT_OFFICERS +
              this.pupilName.substr(0, this.pupilName.indexOf(' '));
          } else {
            this.supportOfficer = x.exclusion.supportOfficer.sort((a, b) =>
              a.name.toLowerCase().localeCompare(b.name.toLowerCase())
            );
          }
        },
        error: (x: any) => {
          if (x.error.statusCode === 404) {
            this.isSupportOfficerAssociated = false;
            this.noSupportOfficerAssociatedText =
              NO_ASSIGNED_SUPPORT_OFFICERS +
              this.pupilName.substr(0, this.pupilName.indexOf(' '));
          } else {
            this.notificationService.showError(
              'Error getting support officers'
            );
          }
        }
      });
  }
}
